/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-14T19:43:31.613
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentTrafficLinePlatformEditInit,
	getRentTrafficLinePlatformView
} from '@api/rentmanage/RentTrafficLinePlatform';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getRentTrafficLinePlatformEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentTrafficLinePlatformEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentTrafficLinePlatformView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentTrafficLinePlatformView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
